import { Rejection, StateService } from '@uirouter/core';

import { CimaToken, CimaUrl } from 'core/services';
import { UserErrorType } from 'my-account/constants';

export function AuthGuard(cimaUrl: CimaUrl, cimaToken: CimaToken, state: StateService): Promise<void> {
    if (state.transition && state.transition.to().name.includes('account.u.')) {
        return Promise.resolve();
    }

    if (!cimaToken.isLoggedIn) {
        cimaUrl.redirectToLogin({ state: state.transition.to().name, params: state.transition.params() });

        return Promise.reject(Rejection.aborted('login first'));
    } else {
        return Promise.resolve();
    }
}

export function AuthLogout(cimaUrl: CimaUrl): Promise<void> {
    cimaUrl.redirectToLogout();

    return Promise.reject(Rejection.aborted('state never allowed to enter'));
}

// Helper functions
export function handleMyAccount403Error(state: StateService, options?: WatchSecondaryUserRouteOptions): Promise<void> {
    if (options && options.isWatch) {
        state.go('watch.non-xfinity-user', { ...options.params, previousStateName: options.previousStateName });
    } else {
        state.go('non-xfinity-customer', { error_type: UserErrorType.SECONDARY_USER });
    }

    return Promise.resolve();
}

export function WatchesAuthGuard(cimaUrl: CimaUrl, cimaToken: CimaToken, state: StateService): Promise<void> {
    if (!cimaToken.isLoggedIn) {
        cimaUrl.redirectToLogin({ state: state.transition.to().name, params: state.transition.params() }, 'watches');

        return Promise.reject(Rejection.aborted('login first'));
    } else {
        return Promise.resolve();
    }
}


export function EsimAuthGuard(cimaUrl: CimaUrl, cimaToken: CimaToken, state: StateService): Promise<void> {
    if (!cimaToken.isLoggedIn) {
        cimaUrl.redirectToLogin({ state: state.transition.to().name, params: state.transition.params() }, 'esim');

        return Promise.reject(Rejection.aborted('login first'));
    } else {
        return Promise.resolve();
    }
}

export function EsimTransferAuthGuard(cimaUrl: CimaUrl, cimaToken: CimaToken, state: StateService): Promise<void> {
    if (!cimaToken.isLoggedIn) {
        cimaUrl.redirectToLogin({ state: state.transition.to().name, params: state.transition.params() });

        return Promise.reject(Rejection.aborted('login first'));
    } else {
        return Promise.resolve();
    }
}

